/**
 * History Item Content Component
 * Wrapper for text, date, and actions within a history item
 * Follows SRP - single responsibility for content layout
 */

import React from 'react';
import Image from 'next/image';
import { spacing } from '@/design-system/utils';
import { HistoryItemText } from './HistoryItemText';
import { HistoryItemDate } from './HistoryItemDate';
import { HistoryItemActions } from './HistoryItemActions';

interface HistoryItemContentProps {
  title: string;
  description?: string;
  date?: string;
  time?: string;
  onShare?: () => void;
  onDelete?: () => void;
}

export const HistoryItemContent: React.FC<HistoryItemContentProps> = ({
  title,
  description,
  date,
  time,
  onShare,
  onDelete,
}) => {
  return (
    <>
      {/* Mobile Layout */}
      <div className='flex flex-col gap-2 w-full md:hidden'>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: spacing[2],
              flex: 1,
              minWidth: 0,
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                width: '32px',
                height: '32px',
                marginTop: '8px',
              }}
            >
              <Image
                src='/assets/images/icons/messages.svg'
                alt='Messages icon'
                width={32}
                height={32}
                unoptimized
                style={{
                  width: '32px',
                  height: '32px',
                  objectFit: 'contain',
                }}
              />
            </div>
            <HistoryItemText title={title} description={description} />
          </div>
          <HistoryItemActions onShare={onShare} onDelete={onDelete} />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            width: '100%',
            paddingLeft: '40px', // Align with text (32px icon + 16px gap)
          }}
        >
          <HistoryItemDate date={date || ''} time={time || undefined} />
        </div>
      </div>

      {/* Desktop Layout */}
      <div className='hidden md:flex md:items-center md:justify-between w-full'>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: spacing[2],
            flex: 1,
            minWidth: 0,
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              width: '32px',
              height: '32px',
              marginTop: '8px',
            }}
          >
            <Image
              src='/assets/images/icons/messages.svg'
              alt='Messages icon'
              width={32}
              height={32}
              unoptimized
              style={{
                width: '32px',
                height: '32px',
                objectFit: 'contain',
              }}
            />
          </div>
          <HistoryItemText title={title} description={description} />
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: spacing[1],
            flexShrink: 0,
          }}
        >
          <HistoryItemDate date={date || ''} time={time || undefined} />
          <HistoryItemActions onShare={onShare} onDelete={onDelete} />
        </div>
      </div>
    </>
  );
};
